import { Component, h } from "preact";
import Vouchers from "../../../../services/vouchers";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { formatDateTime } from "../../utils/date-formats";
import formatCurrency from "../../../../services/currency";
import Config from "../../../../services/config";

import * as U from "../../desktop-templates/menu-user";
import { route } from "preact-router";

import { VouchersPage as AwrabetVouchersPage, VouchersLists } from "../../../awrabet/desktop-components/user/menu-vouchers";

export class VouchersPage extends AwrabetVouchersPage {
    render() {
        return <div>
            <div class="overflow-x-auto user-menu-subnav">
                <U.SubTabsContainer>
                    <U.Tab selected={true}><Trans>Vouchers List</Trans></U.Tab>
                    <U.Tab onClick={e => { route("/user/payment-gateway/deposit") }}><Trans>Deposit</Trans></U.Tab>
                    <U.Tab onClick={e => { route("/user/payment-gateway/withdraw") }}><Trans>Withdraw</Trans></U.Tab>
                </U.SubTabsContainer>
            </div>
            <div class="user-menu-header main-text-color px-2 py-1 text-base font-bold ml-3 mt-2 capitalize"><Trans>Vouchers</Trans></div>
            <VouchersLists allVouchers={this.state.allVouchers} vouchersService={this.vouchersService} />
        </div>
    }
}